import { computed } from 'vue'
import { useDisplay } from 'vuetify'

const TOOLBAR_COMPACT_THRESHOLD = Infinity

export function useToolbarButtonStyle() {
  const display = useDisplay()

  const isCompact = computed(
    () => display.width.value < TOOLBAR_COMPACT_THRESHOLD
  )

  const toolbarBtnProps = computed(() => {
    if (!isCompact.value) {
      return { rounded: true, size: 'x-large' }
    }
    return { height: 45, width: 45, icon: true }
  })

  return { isCompact, toolbarBtnProps }
}
